var ProductInformationSectionSecurityAndComplianceEnum;
(function (ProductInformationSectionSecurityAndComplianceEnum) {
    ProductInformationSectionSecurityAndComplianceEnum["warning"] = "Warning";
    ProductInformationSectionSecurityAndComplianceEnum["safetyInformation"] = "Safety Information";
    ProductInformationSectionSecurityAndComplianceEnum["ageRecommendation"] = "Age recommendations";
    ProductInformationSectionSecurityAndComplianceEnum["testResultsAndCompliance"] = "Test results and compliance";
})(ProductInformationSectionSecurityAndComplianceEnum || (ProductInformationSectionSecurityAndComplianceEnum = {}));
export default ProductInformationSectionSecurityAndComplianceEnum;
//# sourceMappingURL=ProductInformationSectionSecurityAndComplianceEnum.js.map